<template>
  <div class="edit-base-shelf">
    <div class="shelf-item-layout">
      <shelfLibName :setType="setType" :type="type"></shelfLibName>
      <div class="edit-base-shelf-item">
        <div class="edit-shelfname-label">封面装饰<i class="vip">VIP</i></div>
        <ShelfAdorn :decoration="decoration" @adornmentMsn="adornmentMsn" ref="adornment"></ShelfAdorn>
      </div>
      <shelfLibPoster ref="shelfLibPoster" :type="type" :qrObj="qrObj"></shelfLibPoster>
      <shelfSwitchBooks ref="shelfSwitchbook"></shelfSwitchBooks>
      <!-- 打开方式 -->
      <openMode :type="type" />
    </div>
    <div class="shelf-item-layout">
      <shelfLibSetTitle :type="type"></shelfLibSetTitle>
      <shelfLibDesc class="libDesc" :type="type"></shelfLibDesc>
      <shelfLibLogo class="libLogo" :type="type" ref="shelfLogo"></shelfLibLogo>
      <EditQuestionaire ref="editQuestionaire" type="bookShelf"></EditQuestionaire>
    </div>
    <div class="shelf-item-layout thumbnail albumThum">
      <shelfLibThum :type="type"></shelfLibThum>
      <shelfPattern :type="type" />
      <shelfCover type="bookShelf"></shelfCover>
      <edit-charge type="bookShelf" ref="editCharge"></edit-charge>
      <shelf-lib-button-display type="bookShelf"></shelf-lib-button-display>
      <div class="edit-base-shelf-item">
        <span class="edit-shelfname-label">默认语言</span>
        <el-select class="personal-item-select" v-model="language" size="mini">
          <el-option label="中文" :value="0"></el-option>
          <el-option label="英文" :value="1"></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>
<script>
import apis from '@api/bookshelfDetail'
import shelfLibDesc from './shelfLibDesc.vue'
import shelfLibName from './shelfLibName.vue'
import shelfLibSetTitle from './shelfLibSetTitle.vue'
import shelfLibThum from './shelfLibThum.vue'
import ShelfAdorn from '../commonEdit/editAdorn.vue'
import shelfLibLogo from './shelfLibLogo.vue'
import shelfLibPoster from './shelfLibPoster.vue'
import shelfSwitchBooks from './shelfSwitchBooks.vue'
import EditQuestionaire from '@components/commonEdit/editQuestionaire'
import shelfPattern from './shelfPattern.vue'
import openMode from './openMode.vue'
import shelfCover from './shelfCover.vue'
import EditCharge from '../editDrawer/edit/EditCharge'
import ShelfLibButtonDisplay from '@components/editBookShlefLibrary/shelfLibButtonDisplay'
export default {
  name: 'shelfInput',
  data() {
    return {
      setType: '专辑',
      type: {
        getType: 'Shelf',
        setType: 'SHELF'
      },
      qrObj: {
        value: ''
      },
      adornment: '', // 用来保存装饰设置
      decoration: '' // 传递给子组件的装饰初始值
    }
  },
  components: {
    ShelfLibButtonDisplay,
    EditCharge,
    shelfLibDesc,
    shelfLibName,
    shelfLibSetTitle,
    shelfLibThum,
    ShelfAdorn,
    shelfLibLogo,
    shelfLibPoster,
    shelfSwitchBooks,
    EditQuestionaire,
    shelfPattern,
    openMode,
    shelfCover
  },
  computed: {
    albumId() {
      return window.sessionStorage.getItem('albumId')
    },
    logo() {
      return this.$refs.shelfLogo.logo
    },
    url() {
      return this.$refs.shelfLogo.logoUrl
    },
    linkJump() {
      return this.$refs.shelfLogo.linkJump
    },
    switchNewsPaper() {
      return this.$refs.shelfSwitchbook.switchValue
    },
    language: {
      get: function() {
        return this.$store.state.config.bookShelfObj.language
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_OBJ_LANGUAGE', { type: 'bookShelfObj', value: value })
      }
    }
  },
  methods: {
    getAlbumData() {
      const params = { id: this.albumId }
      apis.bookshelfDetail(params).then((res) => {
        if (res && res.data && res.data.code === 0) {
          const data = res.data.data
          // 设置专辑基础数据
          let bookShelfData = {
            ...data,
            displayOrNot: data.switchGroup
              ? { login: 1, collect: 1, search: 1, share: 1, pctitle: 0, hoverQRcode: 1, ...JSON.parse(data.switchGroup) }
              : { login: 1, collect: 1, search: 1, share: 1, pctitle: 0, hoverQRcode: 1 },
            cover: res.data.data.cover || '',
            currentCover: res.data.data.cover || '', // 用于页面展示
            shareDesc: data.description,
            isPoster: data.poster || 0,
            selPoster: data.posterStyle || 0,
            customTit: data.posterTitle || '',
            questionContent: data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(data.questionContent) : {},
            questionContentConstruction: data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(JSON.parse(data.questionContent).construction) : []
          }
          // 当问卷名称为空时，初始需要赋值为书刊名称+问卷
          bookShelfData.questionContent.formName = bookShelfData.questionContent.formName ? bookShelfData.questionContent.formName : bookShelfData.name + '问卷'
          this.$store.commit('config/UPDATE_BOOKSHELFOBJ', bookShelfData)

          let logo = null
          if (res.data.data.logo == 'logo.png' || res.data.data.logo == undefined) {
            logo = 'logo.png'
            this.$refs.shelfLogo.logo = 0
            this.$refs.shelfLogo.uploadLogo = false
          } else {
            logo = res.data.data.logo
            this.$refs.shelfLogo.logo = 1
            this.$refs.shelfLogo.uploadLogo = true
          }
          this.$refs.shelfLogo.linkJump = data.linkJump
          const adornment = res.data.data.adornment
          this.adornment = this.decoration = adornment
          if (res.data.data.url !== undefined) {
            this.$refs.shelfLogo.logoUrl = res.data.data.url
          } else {
            this.$refs.shelfLogo.logoUrl = `${window.PROJECT_CONFIG.BASE_URL}/elecPublish/index.html`
          }

          this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'LOGO', logo)
          const customPosterData = {
            posterQrCodeShow: res.data.data.posterQrCodeShow === undefined || res.data.data.posterQrCodeShow === '' ? 1 : res.data.data.posterQrCodeShow,
            posterNameShow: res.data.data.posterNameShow === undefined || res.data.data.posterNameShow === '' ? 1 : res.data.data.posterNameShow,
            posterName: res.data.data.posterName,
            posterTextShow: res.data.data.posterTextShow === undefined || res.data.data.posterTextShow === '' ? 1 : res.data.data.posterTextShow,
            posterPromptText: res.data.data.posterPromptText,
            posterCover: res.data.data.posterCover ? res.data.data.posterCover.split(',') : [],
            posterPic: res.data.data.posterPic || 'poster.png'
          }
          this.$store.commit('config/UPDATE_POSTERALBUM', customPosterData)
          this.$refs.shelfSwitchbook.switchValue = res.data.data.switchNewsPaper || 0
          if (res.data.data.associationName) {
            this.$store.commit('config/UPDATE_BOOKSHELFRELEVANCETEXT', res.data.data.associationName)
          }
          const posterPic = res.data.data.posterPic || 'poster.png'
          this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'CUSIMG', posterPic)
        }
      })
    },
    adornmentMsn(payload) {
      this.adornment = payload
    },
    check() {
      const checkReason = {
        questionaireCheckReason: this.$refs.editQuestionaire.check()
      }
      return checkReason
    },
    getData() {
      const data = {
        questionaireData: this.$refs.editQuestionaire.getData()
      }
      return data
    }
  },
  mounted() {
    this.getAlbumData()
    this.qrObj.value = window.location.href.replace('list', 'bookshelfdetail?id=') + this.albumId
  }
}
</script>
<style lang="scss" scoped>
.edit-base-shelf {
  display: flex;
  // width: 840px;
  // justify-content: space-between;
  padding-top: 32px;
  .shelf-item-layout {
    margin-right: 70px;
    /deep/ .edit-base-shelf-item {
      font-size: 16px;
      color: #000;
      font-weight: 400;
      margin-bottom: 17px;
      .edit-shelfname-label {
        display: -webkit-flex;
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        img {
          height: 24px;
          margin-left: 2px;
        }
        .vip {
          width: 30px;
          line-height: 20px;
          background: #df5813;
          text-align: center;
          color: #fff;
          font-size: 10px;
          margin-left: 5px;
          border-radius: 2px;
          font-style: normal;
          font-weight: bold;
        }
      }

      .edit-shelfname-input {
        width: 253px;
        height: 27px;
        .el-input__inner {
          height: 27px !important;
          line-height: 27px !important;
        }
      }
      .edit-shelfname-textarea {
        height: 50px !important;
        .el-textarea__inner {
          height: 50px !important;
        }
      }
    }
    .libDesc {
      /deep/ .edit-shelfname-textarea.edit-shelfname-input.el-textarea {
        height: 50px !important;
        .el-textarea__inner {
          height: 50px !important;
          overflow: hidden;
        }
      }
    }
    .libLogo {
      width: 253px;
    }
    &.albumThum.thumbnail {
      /deep/ .thumbnailShelf {
        .base_content {
          height: 100%;
          .imgSize {
            width: 122px !important;
            height: 110px;
          }
          div {
            width: 122px !important;
            background: #df5813;
            color: #fff;
            text-align: center;
            margin-top: -4px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
